import React from 'react';

import { ContextProvider } from '@sravni/react-silent-authentication-form';

import { AuthInlineFormWithContextProviderProps } from './interfaces';
import { AuthInlineForm } from './view';

export const AuthInlineFormWithContextProvider = React.forwardRef<
  HTMLFormElement,
  AuthInlineFormWithContextProviderProps
>((props, ref) => {
  const { metaInfo, userManager, ...rest } = props;

  return (
    <ContextProvider metaInfo={metaInfo} userManager={userManager}>
      <AuthInlineForm {...rest} ref={ref} />
    </ContextProvider>
  );
});
